import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { Config } from '../config';
import { HttpService } from '../services/http.service';

export const useChangelog = () => {
  const queryKey = ['changelog'];

  const path = process.env.REACT_APP_STATIC_PATH || '';

  const queryFn = (): Promise<{ name: string; id: string }[]> => {
    return fetch(`${path}/changelog.json`).then(
      (r) => r.json(),
      () => [],
    );
  };

  return useQuery({
    queryKey,
    queryFn,
  });
};

export const useReleases = () => {
  const queryKey = ['releases'];

  const queryFn = (): Promise<string> => {
    return HttpService.fetchAuthorizedFile(`${Config.API}/api/v1/changelog`).then(
      (r) => r.text(),
      () => '',
    );
  };

  return useQuery({
    queryKey,
    queryFn,
  });
};

export const useIsChangelogModalOpen = () => {
  const queryKey = ['isChangelogModalOpen'];

  const queryFn = () => Promise.resolve<boolean>(false);

  return useQuery({
    queryKey,
    queryFn,
    staleTime: Infinity,
    cacheTime: Infinity,
    gcTime: Infinity,
  });
};

export const setChangelogModalVisible = (value: boolean) => {
  queryClient.setQueryData(['isChangelogModalOpen'], value);
};
